











































import Vue from "vue";
import { authentication } from "@/stores";
import { Route } from "vue-router";
import {
  Tenant,
  TenantOrderSummary,
  TenantOrder,
  transformOrderToSummary,
  SettlementFeeRate
} from "@/models";
import { firestore } from "firebase/app";
import firebaseProject from "@/common/firebaseProject";
import { Collection, Document, List, DocDataRef } from "@/stores";
import { form, autoclose, shopBase } from "@/mixins";
import dayjs from "dayjs";
import { alert, confirm } from "@/services/dialog";

const db = firebaseProject.firestore();

export default shopBase.extend(Vue).extend({
  name: "Sales",
  mixins: [],
  data(): {
    authentication: object;
    transitionName: string;
    startDate: Date;
    endDate: Date;
    targetDate: Date | undefined;
    modelConfig: {
      start: {
        timeAdjust: string;
      };
      end: {
        timeAdjust: string;
      };
    };
    tableColumn: {
      label: string;
      field: string;
      type?: string;
      dateInputFormat?: string;
      dateOutputFormat?: string;
    }[];
    tableData: TenantOrderSummary[];
    settlementFeeRates: SettlementFeeRate[];
  } {
    const queryStart = this.$route.query.start
      ? dayjs(Number(this.$route.query.start)).toDate()
      : dayjs()
          .startOf("day")
          .toDate();
    const queryEnd = this.$route.query.end
      ? dayjs(Number(this.$route.query.end)).toDate()
      : dayjs()
          .endOf("day")
          .toDate();

    return {
      authentication,
      transitionName: "",
      startDate: queryStart,
      endDate: queryEnd,
      targetDate: new Date(),
      modelConfig: {
        start: {
          timeAdjust: "00:00:00"
        },
        end: {
          timeAdjust: "23:59:59"
        }
      },
      tableColumn: [
        {
          label: "開始",
          field: "startDate",
          type: "date",
          dateInputFormat: "yyyyMMdd",
          dateOutputFormat: "yyyy/MM/dd"
        },
        {
          label: "終了",
          field: "endDate",
          type: "date",
          dateInputFormat: "yyyyMMdd",
          dateOutputFormat: "yyyy/MM/dd"
        },
        { label: "レジNO", field: "regino", type: "string" },
        { label: "店コード", field: "shopCode", type: "string" },
        { label: "TTコード", field: "ttcode", type: "string" },
        { label: "ショップ名", field: "shopName", type: "string" },
        { label: "注文件数", field: "orderNum", type: "number" },
        { label: "掛売合計", field: "totalSales", type: "number" },
        { label: "クーポン売上", field: "totalDiscount", type: "number" },
        { label: "税額8%", field: "tax1", type: "number" },
        { label: "税額10%", field: "tax2", type: "number" },
        { label: "カード種別", field: "cardType", type: "string" },
        { label: "クレジット手数料", field: "settlementFee", type: "number" },
        {
          label: "クレジット手数料率",
          field: "settlementFeeRate",
          type: "number"
        }
      ],
      tableData: [],
      settlementFeeRates: []
    };
  },
  async created() {
    await this.refreshData();
  },
  methods: {
    async changeDate() {
      const start = dayjs(this.startDate).valueOf();
      const end = dayjs(this.endDate).valueOf();
      if (start > end) {
        alert({
          title: "エラー",
          text: "期間を正しく選択してください。"
        });
      }
      // 期間エラーの場合もデータの更新は行う→0件になる
      this.$router.push({ query: { start: String(start), end: String(end) } });
      this.refreshData();
    },
    async refreshData() {
      const targetDate = this.startDate;
      const targetEnd = this.endDate;
      const dateParam = this.$route.query.date;
      if (dateParam) {
        this.targetDate = dayjs(dateParam as string).toDate();
      }
      const tenants = await (db.collection(
        "tenant"
      ) as firestore.CollectionReference<Tenant>)
        .where("shopId", "==", this.shopId)
        .get();
      const tenantsData = tenants.docs;

      const dayStart = dayjs(targetDate);
      const dayEnd = dayjs(targetEnd);
      const orders = await (db.collectionGroup(
        "order"
      ) as firestore.CollectionReference<TenantOrder>)
        .where("aeonRegiPaymentRequestTime", ">=", dayStart.valueOf())
        .where("aeonRegiPaymentRequestTime", "<=", dayEnd.valueOf())
        .where("status", "in", [
          "ORDER_SUCCEED",
          "PREPARING",
          "PREPARED",
          "DELIVERING",
          "COMPLETED"
        ])
        .get();

      const settlementFeeRates = await (db.collection(
        `settlementFee`
      ) as firestore.CollectionReference<SettlementFeeRate>).get();
      this.settlementFeeRates = settlementFeeRates.docs.map(item => {
        return item.data();
      });

      const summarizedData: {
        [tenantId: string]: TenantOrderSummary;
      } = {};

      const shopData = await db
        .collection("shop")
        .doc(this.shopId)
        .get();

      const orderSummary = orders?.docs
        .filter(item => {
          return item.data().totalAmount > 0;
        })
        .map(order => {
          const data = order.data();
          const tenant = tenantsData
            ?.find(tenant => tenant.id == data.tenantId)
            ?.data() as Tenant;
          return transformOrderToSummary(
            data,
            tenant,
            dayStart,
            dayEnd,
            this.settlementFeeRates,
            shopData?.data()?.shopCode,
            "1"
          );
        })
        .reduce((res: any, item, index, arr) => {
          if (item) {
            const key = item?.key;
            if (item.key in res) {
              res[item.key].orderNum += 1;
              res[item.key].totalDiscount += item.totalDiscount;
              res[item.key].totalSales += item.totalSales;
              res[item.key].tax1 += item.tax1;
              res[item.key].tax2 += item.tax2;
            } else {
              item.orderNum = 1;
              res[item.key] = item;
            }
            res[item.key].settlementFee += Math.round(
              (item.totalAmount * item.settlementFeeRate) / 100.0
            );
          }
          return res;
        }, summarizedData);

      this.tableData = Object.values(summarizedData);
    },
    downloadCsv() {
      const d = dayjs(this.targetDate).format("YYYY-MM-DD");
      (window as any).jQuery("#summaryTable .vgt-table").tableExport({
        type: "csv",
        csvEncoding: "shift-jis",
        fileName: `SummaryReport-${d}`
      });
    }
  }
});
